/* eslint-disable react/jsx-props-no-multi-spaces */
import React from "react";

import {

  LineChart,

  Line,

  XAxis,

  Tooltip,

  ResponsiveContainer,

} from "recharts";

const data = [
  { month: "Jan", value: 620 },
  { month: "Feb", value: 580 },
  { month: "Mar", value: 450 },
  { month: "Apr", value: 320 },
  { month: "May", value: 200 },
  { month: "Jun", value: 75 },
  { month: "Jul", value: 0 },
  { month: "Aug", value: null },
  { month: "Sep", value: null },
  { month: "Oct", value: null },
  { month: "Nov", value: null },
  { month: "Dec", value: null },
];

const IncomingApplication = ({ title, tooltipLabel = "Count" }) => (
  <div style={{ width: "100%", height: 250 }}>
    <h3 style={{ marginBottom: 20 }}>

      {title}
    </h3>
    <div style={{ fontSize: 28, fontWeight: "bold", marginBottom: -30 }}>

      456
    </div>
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}>
        {/* Only X axis */}
        <XAxis
          dataKey="month"
          axisLine={false}
          tickLine={false}
          interval={0}
          padding={{ left: 20, right: 20 }} 
        />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="value"
          name={tooltipLabel}
          stroke="#45C3B8"
          strokeWidth={4}
          dot={false}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>

);

export default IncomingApplication;
